import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LayoutService } from '../services/layout.service';
import { AuthService } from '../services/auth/auth-service';


export const homeRedirectGuard: CanActivateFn = () => {
    const layoutService = inject(LayoutService);
    const authService = inject(AuthService);
    const router = inject(Router);

    const selectedRoleId = layoutService.selectedRole();
    const user = authService.user();

    const roles = user?.roles ?? [];

    const matchedRole = roles.find((r: any) => r.id === Number(selectedRoleId));

    if (matchedRole?.name?.trim().toLowerCase() === 'admin') {
        return router.createUrlTree(['/role-region']);
    }

    return router.createUrlTree(['/task-list']);
};